
const certificatesModule = {
    namespaced: true,
    state: {
        tile: null,
        modal: {
            open: false,
            data: null,
            type: null,
            status: null,
            total_amount: null,
            pagination: null
        }
    }, 
    actions: {
        getStat({ dispatch, commit, rootState }) {

            return dispatch('v3/API', {
                method: 'cert_and_decl',
                data: {
                    action: 'stat',
                    ogrn: parseInt(rootState.card?.company?.ogrn)
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.code === 0) {
                    commit('setStateObject', { name: 'card.certificates.tile', value: e.data.data }, { root: true })
                }
            }).catch(err => { console.error(err.message) })
        },
        getInfo({ dispatch, commit, rootState }, { type, status, offset, limit }) {
            return dispatch('v3/API', {
                method: 'cert_and_decl',
                data: {
                    action: `${type}Info`,
                    type: status,
                    ogrn: parseInt(rootState.card?.company?.ogrn),
                    offset,
                    limit
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.code === 0) {
                    commit('setStateObject', { name: 'card.certificates.modal.data', value: e.data?.data?.list }, { root: true })
                    commit('setStateObject', { name: 'card.certificates.modal.pagination', value: e.data?.data?.pagination }, { root: true })
                }
            }).catch(err => {
                console.error(err.message)
            })
        },
        changeType({ commit }, { type, status, total_amount }) {
            commit('setStateObject', { name: 'card.certificates.modal.type', value: type }, { root: true })
            commit('setStateObject', { name: 'card.certificates.modal.status', value: status }, { root: true })
            commit('setStateObject', { name: 'card.certificates.modal.total_amount', value: total_amount }, { root: true })
        },
        closeModal({ commit }) {
            commit('setStateObject', { name: 'card.certificates.modal.open', value: false }, { root: true })
        }
    }
}

export default certificatesModule